import type { Lot } from '../data/mockLots';

// The server re-picks the hero on every 1s poll via a volatile metric
// (recent_bids_60s in selectHero's "liveliest" tier), so under active bidding it
// flips between live lots each second and the home screen churns. Pin the
// current hero while it is still live; adopt the server's pick only when there
// is no current hero or the current one has closed (left the live set).
//
// Scheduled / last-win heroes are not made sticky (stickyId === null): they
// don't churn, and a stale scheduled hero shouldn't outlive a real live lot
// appearing. The returned stickyId is what the caller must remember for the
// next poll.
export function resolveStableHero(
  prevId: string | null,
  serverHero: Lot | null,
  live: readonly Lot[],
): { featured: Lot | null; stickyId: string | null } {
  if (prevId) {
    const kept = live.find((l) => l.id === prevId);
    if (kept) return { featured: kept, stickyId: prevId };
  }
  const stickyId = serverHero && live.some((l) => l.id === serverHero.id) ? serverHero.id : null;
  return { featured: serverHero, stickyId };
}
